import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { formatUTC } from '@/utils/func';
import { useAttendanceReport } from '@/hooks/app';
import { Flex, FoldingList } from '@/components/common';

interface Props extends ReturnType<typeof useAttendanceReport> {
  startDate: string;
  endDate: string;
}

const PAGE_SIZE = 30;

export function AttendanceReportMobile({
  startDate,
  endDate,
  fetchReport,
  lazyFetchReports,
  items,
  loading,
  total
}: Props) {
  const [page, setPage] = useState(0);

  const [t] = useTranslation(['common', 'dormitory']);

  useEffect(() => {
    setPage(0);
    fetchReport(0, PAGE_SIZE, startDate, endDate);
  }, [startDate, endDate]);

  const onEndReached = useCallback(() => {
    console.log('onEndReach');
    return setPage((c) => {
      const newPage = c + 1;
      lazyFetchReports(newPage, PAGE_SIZE, startDate, endDate);
      return newPage;
    });
  }, [setPage, lazyFetchReports, startDate, endDate]);

  const rows = items.map((item) => ({
    title: <div className="ltr inline-flex">{formatUTC(item.attendanceDate)}</div>,
    description: item.attendanceType < 0 ? t('common:labels.entry') : t('common:labels.exit'),
    attrs: {
      dormitoryName: {
        title: t('dormitory:labels.location'),
        value: item.dormitoryName
      },
      blockName: {
        title: t('dormitory:labels.block'),
        value: item.blockName
      },
    }
  }));

  const hasMore = page * PAGE_SIZE < total;

  return (
    <Flex className="w-full h-full" direction="column">
      {!loading && rows.length === 0 && (
        <Flex className="w-full mt-2" justify="center">
          <Alert
            type="warning"
            message={t('common:errors.no-items-in-time-frame')} />
        </Flex>
      )}
      <FoldingList
        hasMore={hasMore}
        items={rows}
        onEndReached={onEndReached}
      />
    </Flex>
  );

}

export default AttendanceReportMobile;
